import {
  IonAccordion,
  IonAccordionGroup,
  IonCol,
  IonGrid,
  IonItem,
  IonRow,
} from "@ionic/react";
import { useEffect, useState } from "react";
import ListVideo from "./ListVideo";

import { makePOSTRequest } from "../../request/rawRequest";
import "../generalCSS/stylesheet.css";
import "./List.css";

interface ContainerProps {
  generique?: boolean;
  theme?: Array<{ [key: string]: string }>;
  compID?: string;
}

const ListTheme: React.FC<ContainerProps> = ({ generique, theme, compID }) => {
  const [themeList, setThemeList] = useState<any>([]);
  const [themeListSorted, setThemeListSorted] = useState<any>([]);
  const [vvTitle, setvvTitle] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    const fetchVideos = async () => {
      if (themeList.length === 0) {
        const requests: any = theme?.map((theme) => {
          return makePOSTRequest("/videos", { _id: theme.id_videos });
        });

        const results = await Promise.all(requests);

        const newThemeList = results.map((data, index) => {
          let dataVideo = null;
          if (generique) {
            dataVideo = {
              videos: data.sort((a: any, b: any) => a?.index - b?.index),
            };
          } else {
            dataVideo = data[0];
          }

          if (!generique) {
            return {
              picture_url: theme?.at(index)?.picture_url,
              name: theme?.at(index)?.name,
              id_theme: theme?.at(index)?._id,
              id_nextTheme: theme?.at(
                index === results.length ? index : index + 1
              )?._id,
              ...dataVideo,
            };
          }

          return {
            picture_url: theme?.at(index)?.picture_url,
            name: theme?.at(index)?.name,
            _id: theme?.at(index)?._id,
            ...dataVideo,
          };
        });

        setThemeList(newThemeList);
      }

      //OLD
      // theme?.map(async (theme) => {
      //   console.log("log1", theme.id_videos);

      //   await makePOSTRequest("/videos", { _id: theme.id_videos }).then(
      //     (data) => {
      //       let dataVideo: any = null;
      //       if (generique) {
      //         dataVideo = { videos: data };
      //       } else {
      //         dataVideo = data[0];
      //       }
      //       console.log("log2", theme.id_videos);
      //       setThemeList((o: any) => [
      //         ...o,
      //         {
      //           picture_url: theme.picture_url,
      //           name: theme.name,
      //           _id: theme._id,
      //           ...dataVideo,
      //         },
      //       ]);
      //     }
      //   );
      // });
    };
    fetchVideos();
  }, [theme]);

  useEffect(() => {
    // if (theme?.length === themeList.length && themeList > 0) {
    //   const test = themeList.sort((a: any, b: any) => {
    //     if (a && b && a.index && b.index) {
    //       return a.index - b.index;
    //     }
    //   });
    //   console.log("test: ");
    //   setThemeListSorted(test);
    // }

    // here to sort, if one day someone says....
    if (generique) {
      themeList.map((tl: any) => {
        const amountViewed = tl.videos.filter(
          (v: any) => v.viewed === true
        ).length;

        setvvTitle((old) => {
          old.set(tl._id, amountViewed + "/" + tl.videos.length);
          return new Map(old);
        });
      });
    }
    // setThemeList(test);
  }, [themeList]);

  return (
    <IonRow>
      <IonCol>
        <IonAccordionGroup>
          {themeList.map((theme: any, i: number) => {
            if (generique === true) {
              return (
                <IonAccordion key={i}>
                  <IonItem slot="header" className="ion-no-padding">
                    <IonGrid>
                      <IonRow>
                        <IonCol size-lg="3">
                          <img
                            className="max-height-100 fit-img border-radius border-secondary"
                            src={
                              theme.picture_url.length > 0
                                ? theme.picture_url
                                : "https://t4.ftcdn.net/jpg/00/89/55/15/240_F_89551596_LdHAZRwz3i4EM4J0NHNHy2hEUYDfXc0j.jpg"
                            }
                          ></img>
                        </IonCol>
                        <IonCol
                          className="flex ion-align-items-center firstLetterUpper"
                          style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}
                        >
                          {theme.name }
                        </IonCol>
                        <IonCol
                          className="flex ion-align-items-center"
                          size="3"
                        >
                          <span className="small-font">
                            vidéo vues :{" "}
                            {vvTitle.get(theme._id) ??
                              `no such stat with : ${theme.id} `}
                          </span>
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  </IonItem>
                  <div slot="content">
                    <ListVideo
                      key={i}
                      idTheme={theme._id}
                      id_videos={theme.id_videos}
                      theme={theme}
                      generique={true}
                      compID={generique && generique === true ? compID : ""}
                    />
                  </div>
                </IonAccordion>
              );
            }
            return (
              <ListVideo
                key={i}
                idTheme={theme.id_theme}
                id_videos={theme.id_videos}
                generique={false}
                theme={theme}
                pictureUrl={theme.picture_url ?? ""}
                compID={generique && generique === true ? "" : compID}
              />
            );
          })}
        </IonAccordionGroup>
      </IonCol>
    </IonRow>
  );
};

export default ListTheme;
